import { MapPin, Phone, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-white border-t border-slate-200" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="mb-6">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 645.4 195.7" className="h-8 w-auto">
                <g fill="#1E293B">
                  <path d="M367.6,80.7c-1-2.1,0.3-4.4,2.9-4.4h17.3c1.6,0,2.6,1,2.9,1.9l16,47.4h0.9L437.3,49c0.7-2,3.4-2.4,4.9-0.9L453.2,60c1.3,1.4,1.6,3.6,0.7,5.4l-43.4,94.1c-0.6,1-1.4,1.9-2.9,1.9H406c-1.6,0-2.4-0.9-2.9-1.9L367.6,80.7z"/>
                  <path d="M320,59.6c0-1.3,1-2.4,2.4-2.4h12.7c1.3,0,2.4,1.1,2.4,2.4l1.1,76l33.4-2.3c1.4,0,2.4,1.1,2.4,2.4v11.9c0,1.3-1,2.4-2.4,2.4h-49.8c-1.4,0-2.4-1.1-2.4-2.4V59.6H320z"/>
                  <path d="M624,59.5c0-1.3,1.1-2.4,2.4-2.4h12.1c1.3,0,2.4,1.1,2.4,2.4v88.1c0,1.3-1.1,2.4-2.4,2.4h-12.1c-1.3,0-2.4-1.1-2.4-2.4V59.5z"/>
                  <path d="M538.8,57.9c-0.7-0.7-1.3-0.9-2.3-0.9h-2c-1.3,0-2.4,1-2.4,2.4v88.2c0,1.3,1.1,2.4,2.4,2.4h12c1.4,0,2.4-1.1,2.4-2.4V91.3h0.3l48,57.8c0.7,0.7,1.3,0.9,2.3,0.9h7.6c1.3,0,2.4-1,2.4-2.4v-14.3L538.8,57.9z"/>
                  <path d="M609.6,126.1V59.5c0-1.3-1.1-2.4-2.4-2.4h-12c-1.4,0-2.4,1.1-2.4,2.4V102L609.6,126.1z"/>
                  <path d="M224,146.6l40.8-88.2c0.4-0.9,1-1.4,2.3-1.4h1.3c1.3,0,1.9,0.7,2.3,1.4l40.4,88.2c0.9,1.7-0.3,3.4-2.3,3.4h-11.4c-2,0-2.9-0.9-3.9-2.6l-7.1-14.1h-37.7l-7.3,14.1c-0.6,1.3-1.7,2.6-3.9,2.6h-11.4C224.2,150,223.2,148.3,224,146.6z M279.6,119.9l-12.1-21.4l-12,21.4H279.6z"/>
                  <path d="M225.7,98.4v2.3c0,26-13.3,49.1-41.8,49.1c-26.8,0-43.8-22.7-43.8-48.1c0-26.3,17.4-46.4,45-46.4c14.4,0,27.1,6.7,34.6,18.7c1.1,1.7,0.4,4-1.3,5l-9.6,5.1c-1.7,0.9-3.7,0.3-4.7-1.3c-4.1-6.6-11.1-10.6-19.4-10.6c-17.3,0-25.8,14.1-25.8,29.4s8.7,32.3,26,32.3c11.3,0,20.7-9.7,21-20.8l-16.7-1c-1.3-0.1-2.1-1.1-2.1-2.4V98.4H225.7z"/>
                  <path d="M437,146.6l40.8-88.2c0.4-0.9,1-1.4,2.3-1.4h1.3c1.3,0,1.9,0.7,2.3,1.4l40.4,88.2c0.9,1.7-0.3,3.4-2.3,3.4h-11.4c-2,0-2.9-0.9-3.9-2.6l-7.1-14.1h-37.7l-7.3,14.1c-0.6,1.3-1.7,2.6-3.9,2.6h-11.4C437.3,150,436.3,148.3,437,146.6z M492.7,119.9l-12.1-21.4l-12,21.4H492.7z"/>
                </g>
              </svg>
            </div>
            <p className="font-body text-galvani-textLight text-sm leading-relaxed max-w-md mb-6">
              Productora audiovisual especializada en videopodcasts B2B en Madrid.
              Producción profesional que convierte tu expertise en el activo de marketing más potente.
            </p>
            <p className="font-body text-galvani-textLight text-xs leading-relaxed max-w-md">
              <strong className="text-galvani-text">Galvani Studios SL</strong> · N.I.F. B42810549<br />
              C/ Fernando el Católico 57, local · 28015 Madrid
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading font-semibold text-galvani-text mb-4">
              Contacto
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="tel:+34683397873"
                  className="flex items-center gap-3 text-galvani-textLight hover:text-galvani-purple transition-colors font-body text-sm"
                  data-testid="footer-phone-link"
                >
                  <Phone size={16} />
                  +34 683 39 78 73
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@galvanistudios.com"
                  className="flex items-center gap-3 text-galvani-textLight hover:text-galvani-purple transition-colors font-body text-sm"
                  data-testid="footer-email-link"
                >
                  <Mail size={16} />
                  info@galvanistudios.com
                </a>
              </li>
              <li className="flex items-start gap-3 text-galvani-textLight font-body text-sm">
                <MapPin size={16} className="mt-0.5 flex-shrink-0" />
                <span>
                  Fernando el Católico 57, Local
                  <br />
                  Madrid, 28015
                </span>
              </li>
            </ul>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-heading font-semibold text-galvani-text mb-4">
              Recursos
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="#beneficios" className="text-galvani-textLight hover:text-galvani-purple transition-colors font-body text-sm">
                  Beneficios
                </a>
              </li>
              <li>
                <a href="#proceso" className="text-galvani-textLight hover:text-galvani-purple transition-colors font-body text-sm">
                  Proceso
                </a>
              </li>
              <li>
                <a href="#solicitar-propuesta" className="text-galvani-textLight hover:text-galvani-purple transition-colors font-body text-sm">
                  Solicitar propuesta
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-slate-200 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-galvani-textLight font-body text-sm">
            © {new Date().getFullYear()} Galvani Studios SL. Todos los derechos reservados.
          </p>
          <div className="flex flex-wrap justify-center gap-6">
            <a
              href="/agencias"
              className="text-galvani-purple hover:underline font-body text-sm font-medium transition-colors"
              data-testid="footer-agencies-link"
            >
              ¿Eres agencia?
            </a>
            <a
              href="/politica-privacidad"
              className="text-galvani-textLight hover:text-galvani-purple font-body text-sm transition-colors"
              data-testid="footer-privacy-link"
            >
              Política de Privacidad
            </a>
            <a
              href="/politica-cookies"
              className="text-galvani-textLight hover:text-galvani-purple font-body text-sm transition-colors"
              data-testid="footer-cookies-link"
            >
              Política de Cookies
            </a>
            <button
              type="button"
              onClick={() => window.dispatchEvent(new Event("open-cookie-settings"))}
              className="text-galvani-textLight hover:text-galvani-purple font-body text-sm transition-colors"
              data-testid="footer-cookie-settings-link"
            >
              Configurar cookies
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
